import * as turf from '@turf/turf';

import ArrowIcon from '../components/icons/ArrowIcon';
import GridIcon from '../components/icons/GridIcon';
import KeylineIcon from '../components/icons/KeylineIcon';
import LineIcon from '../components/icons/LineIcon';
import { sectionTypes } from '../constants/fields';

export const getIconForSectionType = (sectionType) => {
  switch (sectionType) {
    case sectionTypes.LINE: {
      return <LineIcon />;
    }
    case sectionTypes.KEYLINE: {
      return <KeylineIcon />;
    }
    case sectionTypes.IMPORTED: {
      return <ArrowIcon />;
    }
    default: {
      return <GridIcon />;
    }
  }
};

export const getSectionBounds = (section) => {
  const { type, rows, fieldFeature } = section;
  if (!rows || !fieldFeature) return null;
  return turf.bbox(
    type === sectionTypes.LINE
      ? turf.featureCollection(rows?.features)
      : fieldFeature,
  );
};

export const getSectionGroupBounds = (sectionGroup, sections) => {
  const sectionIds = sectionGroup.sections.map((section) => section.id);
  const sectionGroupFeatures = turf.featureCollection(
    sections
      .filter((section) => sectionIds.includes(section.id))
      .flatMap(({ type, rows, fieldFeature }) =>
        // The rows field feature is only a single row, so we need to include
        // all rows to get the entire field. Using the polygon boundary
        // fieldFeature in other cases is more efficient.
        type === sectionTypes.LINE ? rows?.features : [fieldFeature],
      ),
  );
  return turf.bbox(sectionGroupFeatures);
};

export const sectionHasGeodata = (section) => {
  if (!section) return false;
  const { rows, points } = section;
  return !!rows && !!points;
};
